import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {NotFoundComponent} from "./shared-module/not-found/not-found.component";
import {WidgetStatusComponent} from "./widget/payment-widget/widgetStatus/widget-status.component";
import {AcademWidgetComponent} from "./widget/payment-widget/academ-widget/academ-widget.component";
import {DefaultWidgetComponent} from "./widget/payment-widget/default-widget/default-widget.component";
import {IntegrationComponent} from './integration/integration.component';
import {AuthGuard} from './_guards/auth.guard';
import {HashCheckComponent} from "./main-page/setting-part/hash-check/hash-check.component";
import {AliasGuard} from "./tmpName/alias.guard";
import {MeterWidgetAuthComponent} from './widget/send-values-widget/auth/auth.component';
import {AliasWithoutStorageGuard} from "./tmpName/alias-without-storage.guard";
import {AliasWithoutActiveCheckGuard} from "./tmpName/alias-without-active-check.guard";
import {InactiveInfoComponent} from "./tmpName/inactive-info/inactive-info.component";

const appRoutes: Routes = [
  {
    path: 'error',
    component: NotFoundComponent
  },
  {
    path: '',
    component: NotFoundComponent
  },
  {
    path: 'monoblock',
    loadChildren: 'app/monoblock/monoblock.module.ts#MonoblockModule',
  },
  {
    path: 'info/:alias',
    canActivate: [AliasWithoutActiveCheckGuard],
    children: [
      {
        path: 'inactive-info',
        component: InactiveInfoComponent
      }
      ]
  },
  {
    path: 'iframe/:alias',
    canActivate: [AliasWithoutStorageGuard],
    children: [
      {
        path: 'widget',
        component: DefaultWidgetComponent
      },
      {
        path: 'akademWidget',
        component: AcademWidgetComponent
      },
      {
        path: 'payment_success',
        component: WidgetStatusComponent,
        data: {
          status: 'SUCCESS'
        }
      },
      {
        path: 'payment_success1',
        component: WidgetStatusComponent,
        data: {
          status: 'SUCCESS',
          action: 'CLOSE'
        }
      },
      {
        path: 'payment_failed',
        component: WidgetStatusComponent,
        data: {
          status: 'FAIL'
        }
      },
      {
        path: 'send_values_widget',
        // component: SendValuesWidgetComponent
        component: MeterWidgetAuthComponent
      }
    ]
  },
  {
    path: ':alias',
    canActivate: [AliasGuard],
    children: [
      {
        path: 'widget',
        component: DefaultWidgetComponent
      },
      {
        path: 'akademWidget',
        component: AcademWidgetComponent
      },
      {
        path: 'payment_success',
        component: WidgetStatusComponent,
        data: {
          status: 'SUCCESS'
        }
      }
      ,
      {
        path: 'payment_success1',
        component: WidgetStatusComponent,
        data: {
          status: 'SUCCESS',
          action: 'CLOSE'
        }
      },
      {
        path: 'payment_failed',
        component: WidgetStatusComponent,
        data: {
          status: 'FAIL'
        }
      },
      {
        path: 'send_values_widget',
        // component: SendValuesWidgetComponent
        component: MeterWidgetAuthComponent
      },
      {
        path: '',
        loadChildren: 'app/tmpName/tmpName.module#TmpNameModule'
      },

      {
        path: '',
        // canActivate: [AuthGuard],
        children: [
          {
            path: 'integrations',
            component: IntegrationComponent,
            canActivate: [AuthGuard],
            data: {
              roles: ['ROLE_API', 'ROLE_SUPER_ADMIN']
            }
          },
          {
            path: '',
            loadChildren: 'app/main-page/main-page.module#MainPageModule',
            canActivate: [AuthGuard],
            data: {
              roles: ['ROLE_USER']
            }
          },
          {
            path: '',
            loadChildren: 'app/administration-module/administration-main.module#AdministrationModule',
            canActivate: [AuthGuard],
            data: {
              roles: ['ROLE_ADMIN']
            }
          },

        ]
      },
    ]
  },
  {
    path: 'email/:alias/:user/:hash',
    component: HashCheckComponent,
    canActivate: [AliasGuard],
    pathMatch: 'prefix',
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes,
       // {enableTracing: true}
  )],
  exports: [RouterModule]
})
export class MainRoutingModule {
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/app.routing.ts